<template>
    <a-card :title="$t('screenTitle.articleList')">
        <div class="mb-20">
            <router-link :to="{ name: RouteName.ARTICLES_NEW }">
                <a-button type="primary"><template #icon><FormOutlined /></template> {{ $t('screenTitle.articleNew') }}</a-button>
            </router-link>
        </div>
        <a-table :dataSource="dataSource" :columns="columns" :pagination="pagination" :loading="isLoading">
            <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'action'">
                    <a-space>
                        <router-link :to="{ name: RouteName.ARTICLES_DETAIL, params: { article_id: record.id } }">
                            <a-button type="primary"><template #icon><FormOutlined /></template></a-button>
                        </router-link>

                        <a :href="getArticleViewUrl(record)" target="_blank">
                            <a-button type="primary"><template #icon><link-outlined /></template></a-button>
                        </a>

                        <a-button type="primary" danger @click="deleteConfirm(record)"><template #icon><DeleteOutlined /></template></a-button>
                    </a-space>
                </template>
            </template>
        </a-table>
    </a-card>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";

import { Button, Card, message, Modal, Space, Table, TablePaginationConfig } from "ant-design-vue";
import { FormOutlined, DeleteOutlined, LinkOutlined, } from '@ant-design/icons-vue';

import { RouteName } from "@/router";
import ApiRequest from "@/utils/ApiRequest";
import { useI18n } from "vue-i18n";
import { ColumnType } from "ant-design-vue/lib/table";

export default defineComponent({
    components: {
        ACard: Card,
        ATable: Table,
        AButton: Button,
        ASpace: Space,

        FormOutlined,
        DeleteOutlined,
        LinkOutlined,
    },

    setup() {
        const { t } = useI18n();

        const isLoading = ref(true);
        const dataSource = ref([]);
        const columns = ref<ColumnType[]>([
            {
                title: t('labelText.article_title'),
                dataIndex: "title",
                key: "title",
            },
            {
                title: "Author",
                dataIndex: ['author', 'name'],
            },
            {
                title: "Date",
                dataIndex: "created_at",
            },
            {
                title: t('text.action'),
                key: 'action',
            },
        ]);
        const pagination = ref<TablePaginationConfig>({});

        const fetchData = (page = 1) => {
            isLoading.value = true;

            ApiRequest.get('/articles', {
                page,
            }).then((response) => {
                const resData = response.data;
                dataSource.value = resData.data;

                ApiRequest.setPaginate(pagination.value, resData);
            })
            .finally(() => {
                isLoading.value = false;
            });
        };

        pagination.value.onChange = (page) => {
            fetchData(page);
        };

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deleteConfirm = (record: any) => {
            Modal.confirm({
                title: t('message.deleteConfirmContent'),
                content: record.title,
                autoFocusButton: 'cancel',
                maskClosable: true,
                onOk: async () => {
                    return ApiRequest.del('/articles/' + record.id).then(() => {
                        message.success(t('message.deleteSuccess'));
                    })
                    .finally(() => {
                        fetchData(pagination.value.current);
                    });
                },
            });
        };

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const getArticleViewUrl = (record: any) => {
            const loc = window.location;
            const locHost = loc.host;
            const domain = !locHost.indexOf("localhost:") ? (locHost + ApiRequest.API_BASE_URL + '/fronts') : locHost.split('.').slice(1).join('.');
            return `//${domain}/news/${record.slug}`;
        };

        onMounted(() => {
            fetchData();
        });

        return {
            dataSource,
            columns,
            pagination,
            isLoading,

            fetchData,
            deleteConfirm,

            getArticleViewUrl,

            RouteName,
        };
    },
})
</script>

<style scoped>

</style>
